import React from 'react';
import { object, bool, func, string } from 'prop-types';
import useStyles from 'hooks/useStyles';
import cx from 'classnames';

import { ScheduleAddedIcon, ScheduleNormalIcon } from 'components/Icon';

import styles from './SaveLessonButton.scss';

function SaveLessonButton({ isSaved, onClick, className, theme }) {
  useStyles(styles, theme);
  return (
    <div className={cx(styles.root, className)} onClick={onClick}>
      {isSaved ? (
        <ScheduleAddedIcon className={cx(styles.savedIcon, theme.savedIcon)} />
      ) : (
        <ScheduleNormalIcon
          className={cx(styles.normalIcon, theme.normalIcon)}
        />
      )}
    </div>
  );
}
SaveLessonButton.propTypes = {
  isSaved: bool.isRequired,
  onClick: func.isRequired,
  className: string,
  theme: object,
};

SaveLessonButton.defaultProps = {
  className: '',
  theme: styles,
};

export default SaveLessonButton;
